import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { paths } from '../../shared/configs/routing';

const ProtectedRoute = ({ children }) => {
  const { location } = useHistory();

  if (!location?.state?.from) {
    return <Redirect to={paths.main} />;
  }

  return children;
};

export default ProtectedRoute;
